import actions from "@/store/modules/product/actions";
import mutations from "@/store/modules/product/mutations";
import state from "@/store/modules/product/state";

export default {
    actions,
    mutations,
    state
}